module.exports = __webpack_public_path__ + "img/dialog1-box-glod.c6e82b77.png";